<div class="wrapper">
  <div class="toggle-switch">
    <div class="toggle-btn" routerLink="/liste" routerLinkActive="active">
      Liste
    </div>
    <div class="toggle-btn" routerLink="/carte" routerLinkActive="active">
      Carte
    </div>
  </div>
</div>
